import { render, staticRenderFns } from "./BarrasProductos.vue?vue&type=template&id=88edca84&"
import script from "./BarrasProductos.vue?vue&type=script&lang=js&"
export * from "./BarrasProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports